import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { clearSectionAttendanceStats, getSectionAttendance, getArchivedEducationGroups, getArchievedMentorGroups, getEducationGroups, getMentorGroups, getSection, updateArchived } from 'actions/sections';
import UserMentorSection from 'components/List/UserMentorSection';
import MentorSectionForm from 'containers/Forms/MentorSectionForm';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import MyTasks from 'containers/Overview/Sections/MyAssignments';
import SectionProgress from 'containers/Progress/Section';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import { getUserAssessmentDates } from 'helpers/user';
import Moment from 'moment';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Spinner } from 'UI';
import DateTime from '_class/DateTime';
import SectionInformation from '../Functionality/SectionInformation';
import SectionPlans from '../Functionality/SectionPlans';
import SectionPosts from '../Functionality/SectionPosts';
import SectionTools from '../Functionality/SectionTools';
import { setPageTitle } from 'actions/header';
import User from '_class/User';
import DatePickers from 'containers/Progress/Partials/DatePickers';

var CompulsorySchoolSection = /*#__PURE__*/function (_Component) {
  _inherits(CompulsorySchoolSection, _Component);

  var _super = _createSuper(CompulsorySchoolSection);

  function CompulsorySchoolSection(props) {
    var _this;

    _classCallCheck(this, CompulsorySchoolSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener('hashchange', _this.onHashChange);
    });

    _defineProperty(_assertThisInitialized(_this), "onHashChange", function () {
      if (window.location.hash == '#attendance') {
        if (_this.props.group.type == 'MENTOR_GROUP' && _this.props.attendance == null) {
          _this.getAttendanceData();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAttendanceData", function () {
      var start = Moment(_this.state.start).format("YYYY-MM-DD");
      var end = Moment(_this.state.end).format("YYYY-MM-DD");

      _this.props.clearSectionAttendanceStats();

      _this.props.getSectionAttendance(_this.props.group.id, start, end);
    });

    _defineProperty(_assertThisInitialized(_this), "isUserOwner", function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          group = _this$props.group;

      if (currentUser == null || group == null) {
        return false;
      }

      var foundOwner = group.owners.find(function (owner) {
        return currentUser.id == owner.id;
      });

      if (foundOwner != null) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "EditButton", function () {
      var user = new User(_this.props.currentUser);

      var isOwner = _this.props.group.owners.find(function (owner) {
        return owner.userId == _this.props.currentUser.id;
      });

      if (!user.isStudent() && isOwner != null) {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
          onClick: _this.openModal,
          disabled: _this.props.group.archived,
          type: "secondary"
        }, _this.props.translate('Edit')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "CreateLessonButton", function () {
      var user = new User(_this.props.currentUser);

      if (!user.isStudent()) {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.openModal,
          disabled: _this.props.group.archived
        }, _this.props.translate('create-lesson')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "ArchiveButton", function () {
      var user = new User(_this.props.currentUser);

      if (!user.isStudent()) {
        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.makeArchive
        }, _this.props.translate(_this.props.group.archived ? 'Restore' : 'Archive')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "makeArchive", function () {
      var groupId = _this.props.match.params.groupId;
      var _this$props2 = _this.props,
          translate = _this$props2.translate,
          group = _this$props2.group;
      swal.fire({
        title: translate('are-you-sure'),
        html: group.archived ? translate('Are you sure you want to reset this group?') : translate('Both the group and the Microsoft Team will be archived.<br /><br />Do you want to archive this group?'),
        showCancelButton: true,
        cancelButtonText: translate('No'),
        confirmButtonText: translate('Yes')
      }).then(function (result) {
        if (result.value != null) {
          _this.props.updateArchived(group).then(function () {
            _this.setState({
              loading: true
            });

            _this.props.getSection(groupId).then(function () {
              _this.setState({
                loading: false
              });
            });

            if (group.type == 'EDUCATION_GROUP') {
              _this.props.getEducationGroups();
            }

            if (group.type == 'MENTOR_GROUP') {
              _this.props.getMentorGroups();
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reRender, skipPrompt) {
      if (skipPrompt) {
        var groupId = _this.props.match.params.groupId;

        if (reRender) {
          _this.setState({
            loading: true
          });

          _this.props.getSection(groupId).then(function () {
            _this.setState({
              loading: false
            });
          });
        }

        _this.setState({
          modalIsOpen: false
        });
      } else {
        _this.setState({
          modalIsOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupContent", function () {
      var _this$props3 = _this.props,
          group = _this$props3.group,
          currentUser = _this$props3.currentUser;
      var user = new User(_this.props.currentUser);
      var hasAssignments = _this.props.services.haldor || _this.props.services.microsoft;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: _this.EditButton,
        ArchiveButton: _this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        archived: _this.props.group.archived,
        disableCreate: !_this.isUserOwner()
      })) : null, _this.props.services.plans ? /*#__PURE__*/React.createElement("div", {
        id: "section-planning",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPlans, {
        groupid: group.id,
        archived: _this.props.group.archived,
        dateRestriction: false,
        locked: group.locked,
        disableCreate: !_this.isUserOwner()
      })) : null, hasAssignments ? /*#__PURE__*/React.createElement("div", {
        id: "section-groups",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(MyTasks, {
        groupid: group.id,
        archived: _this.props.group.archived,
        locked: group.locked,
        disableCreate: !_this.isUserOwner(),
        overview: true
      })) : null, group.students && group.students.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        id: "section-pupils",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(TeacherSectionProgress, {
        groupId: group.id
      })) : null, user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        id: "section-assessment",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionProgress, {
        groupId: group.id,
        userId: currentUser.userId
      })) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;
      localStorage.setItem('assessment-start-date', new DateTime(start).getDateStamp());
      localStorage.setItem('assessment-end-date', new DateTime(end).getDateStamp());

      _this.setState({
        start: start,
        end: end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateStats", function () {
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;

      _this.props.clearSectionAttendanceStats();

      _this.props.getSectionAttendance(_this.props.group.id, start, end);

      _this.setState({
        currentStart: start,
        currentEnd: end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMentorGroupActions", function () {
      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: _this.state.start,
        endDate: _this.state.end,
        onChange: _this.onDateChange
      }), /*#__PURE__*/React.createElement(Button, {
        style: {
          marginTop: '1rem'
        },
        type: "secondary",
        onClick: _this.onUpdateStats
      }, _this.props.translate('update'))))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), _this.renderDateFilterText(), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDateFilterText", function () {
      if (Moment().isSame(Moment(_this.state.currentEnd), 'day')) {
        return null;
      }

      var translate = _this.props.translate;
      var _this$state2 = _this.state,
          currentStart = _this$state2.currentStart,
          currentEnd = _this$state2.currentEnd;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red',
          marginTop: '1rem',
          fontWeight: 'bold'
        }
      }, translate('Showing data beween'), " ", Moment(currentStart).format('YYYY-MM-DD'), " ", translate('to').toLowerCase(), " ", Moment(currentEnd).format('YYYY-MM-DD'));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMentorGroup", function () {
      var group = _this.props.group;
      var user = new User(_this.props.currentUser);
      var isOwnerOrAdmin = _this.props.group.owners.find(function (owner) {
        return owner.userId == _this.props.currentUser.id;
      }) || user.isAdministrator();
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(MentorSectionForm, {
        onAbort: _this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: _this.EditButton,
        ArchiveButton: _this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        disableCreate: !_this.isUserOwner()
      })) : null, group.students && group.students.length > 0 && (user.isMentor() || isOwnerOrAdmin != null) ? /*#__PURE__*/React.createElement(UserMentorSection, {
        section: group,
        attendance: _this.props.attendance,
        renderActions: _this.renderMentorGroupActions,
        start: _this.state.currentStart,
        end: _this.state.currentEnd
      }) : null);
    });

    _this.state = {
      modalIsOpen: false,
      loading: false,
      end: getUserAssessmentDates().end,
      start: getUserAssessmentDates().start,
      currentEnd: getUserAssessmentDates().end,
      currentStart: getUserAssessmentDates().start
    };
    return _this;
  }

  _createClass(CompulsorySchoolSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var groupId = this.props.match.params.groupId;

      if (groupId != null && groupId != undefined && groupId != "") {
        this.setState({
          loading: true
        });
        this.props.getSection(groupId, true, 'members_expand;').then(function () {
          _this2.setState({
            loading: false
          });

          if (_this2.props.group != null) {
            _this2.props.setPageTitle(_this2.props.group.title);

            if (window.location.hash == '#attendance') {
              if (_this2.props.group.type == 'MENTOR_GROUP' && _this2.props.attendance == null) {
                _this2.getAttendanceData();
              }
            }
          }
        });
      }

      window.addEventListener('hashchange', this.onHashChange, false);
    }
  }, {
    key: "render",
    value: function render() {
      var group = this.props.group;

      if (!group || this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      switch (group.type) {
        case "EDUCATION_GROUP":
          return this.renderGroupContent();

        case "MENTOR_GROUP":
          return this.renderMentorGroup();

        default:
          return this.renderGroupContent();
      }
    }
  }]);

  return CompulsorySchoolSection;
}(Component);

function mapStateToProps(state) {
  return {
    group: state.sections.activeSection,
    currentUser: state.user.currentUser,
    attendance: state.sections.sectionAttendance,
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices
  };
}

export default withRouter(connect(mapStateToProps, {
  getSection: getSection,
  updateArchived: updateArchived,
  getEducationGroups: getEducationGroups,
  getArchivedEducationGroups: getArchivedEducationGroups,
  clearSectionAttendanceStats: clearSectionAttendanceStats,
  getSectionAttendance: getSectionAttendance,
  setPageTitle: setPageTitle,
  getMentorGroups: getMentorGroups,
  getArchievedMentorGroups: getArchievedMentorGroups
})(CompulsorySchoolSection));